const VIEW_PATHS = {
  News: "/news",
  Collective: "/collective"
};

export function getViewPath(view) {
  return VIEW_PATHS[view] || view;
}
